import { IKImage } from 'imagekitio-react'
import React, { useEffect } from 'react'
import './style/frenchcroen.css'
import '../style/responsive.css'
import { Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';


const AllFrenchCrown = (props) => {
  let navigate = useNavigate()

  const navigateCategory = async () => {
    const prdcategory = props.id;
    navigate(`/category?prdcategory=${prdcategory}`);
  }

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  return (
    <Card className=" main-crown-page mt-16" data-aos="fade-up"
      data-aos-anchor-placement="top-bottom">
      <CardContent className=" rounded overflow-hidden  all-crown-card">
        <div className="img-hover-zoom--slowmo rounded w-96 h-full">
          {props.cateimg && typeof props.cateimg === 'string' && (
            <IKImage
              src={JSON.parse(props.cateimg).url}
              style={{ width: "100%", height: "100%", objectFit: 'cover' }}
              className='img'
            />
          )}
          <div className="Maintitle">
            <p className="title">{props.catename}</p>
            <span
              onClick={navigateCategory}
              variant="contained"
              className="bg-black text-white py-0.5 px-7 hover:bg-transparent  hover:border-solid border-2 border-black hover:text-black buttonQueens"
            >
              View All
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default AllFrenchCrown
